import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {FormTO} from "../classes/form-to";
import {FormPublicationTO} from "../classes/form-publication-to";
import {BooleanTO} from "../classes/boolean-to";

@Injectable({
  providedIn: 'root'
})
export class FormService {

  constructor(private http: HttpClient) {}

  public getFormsLite(): Observable<Object> {
    return this.http.get('/rest/form/list/lite');
  }

  public getForms(): Observable<Object> {
    return this.http.get('/rest/form/list');
  }

  public hasExport(formId: number): Observable<BooleanTO> {
    return this.http.get<BooleanTO>(`/rest/form/has/export?f=` + formId);
  }

  public onDeleteForm(form: FormTO): Observable<Object> {
    return this.http.request('delete', '/rest/form/delete', {body: form});
  }

  public getFormTOModel(form: FormTO): Observable<Object> {
    // console.log('getFormTOModel.form');
    // console.dir(form);
    return this.http.post('/rest/form/model', form);
  }

  public getFormShares(form: FormTO): Observable<Object> {
    return this.http.post('/rest/form/shares', form);
  }

  public getFormPublications(form: FormTO): Observable<FormPublicationTO[]> {
    return this.http.post<FormPublicationTO[]>('/rest/form/publications', form);
  }

  public publishForm(form: FormTO): Observable<FormPublicationTO> {
    return this.http.post<FormPublicationTO>('/rest/form/publish', form);
  }

}
